import ChatIcon from "@mui/icons-material/Chat";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import {Box, Card, Stack, Typography} from "@mui/material";
import {CommonThemeColors} from "crqlar-react-common/dist/components/theme";
import {useTranslation} from "react-i18next";
import {useAssistant} from "../assistant/AssistantPanelContext";

const Support = () => {
    const {t} = useTranslation();
    const assistant = useAssistant();

    return (
        <Stack gap={2}>
            <Typography variant="h6" fontWeight={600}>
                {t("Support")}
            </Typography>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                    },
                    rowGap: 1.5,
                    columnGap: 2,
                }}
            >
                <Card
                    component="button"
                    type="button"
                    onClick={() => assistant?.open()}
                    disabled={!assistant}
                    variant="outlined"
                    sx={{
                        cursor: assistant ? "pointer" : "default",
                        color: "inherit",
                        borderColor: "divider",
                        boxShadow: "none",
                        borderRadius: 3,
                        font: "inherit",
                        p: 0,
                        width: "100%",
                        textAlign: "left",
                        "&:hover": {
                            bgcolor: assistant ? "action.hover" : "background.paper",
                        },
                        "&:disabled": {
                            opacity: 0.55,
                        },
                    }}
                >
                    <Stack
                        gap={1.5}
                        direction="row"
                        alignItems="center"
                        sx={{
                            p: 1.5,
                            width: "100%",
                            minHeight: 72,
                            boxSizing: "border-box",
                        }}
                    >
                        <Box
                            aria-hidden="true"
                            sx={{
                                width: 40,
                                height: 40,
                                color: CommonThemeColors.sys.primary.main,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <ChatIcon
                                sx={theme => ({
                                    [theme.breakpoints.down("md")]: {
                                        fontSize: 20,
                                    },
                                })}
                            />
                        </Box>

                        <Typography variant="h6">
                            {t("Crqlar Assistant")}
                        </Typography>
                    </Stack>
                </Card>

                <Card
                    component="a"
                    href="https://crqlar.notion.site/Knowledge-Base-new-35f9e2a69b99804b8c9fd83f4f795e87"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    sx={{
                        cursor: "pointer",
                        color: "inherit",
                        textDecoration: "none",
                        borderColor: "divider",
                        boxShadow: "none",
                        borderRadius: 3,
                        width: "100%",
                        "&:hover": {
                            bgcolor: "action.hover",
                        },
                    }}
                >
                    <Stack
                        gap={1.5}
                        direction="row"
                        alignItems="center"
                        sx={{
                            p: 1.5,
                            width: "100%",
                            minHeight: 72,
                            boxSizing: "border-box",
                        }}
                    >
                        <Box
                            aria-hidden="true"
                            sx={{
                                width: 40,
                                height: 40,
                                color: CommonThemeColors.sys.primary.main,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <SchoolOutlinedIcon
                                sx={theme => ({
                                    [theme.breakpoints.down("md")]: {
                                        fontSize: 20,
                                    },
                                })}
                            />
                        </Box>

                        <Typography variant="h6">
                            {t("Knowledge Base")}
                        </Typography>
                    </Stack>
                </Card>
            </Box>
        </Stack>
    );
};

export default Support;
